import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ellipse",
  "use": "icon-ellipse-usage",
  "viewBox": "0 0 4 4",
  "content": "<symbol viewBox=\"0 0 4 4\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ellipse\">\n<circle cx=\"2\" cy=\"2\" r=\"2\" fill=\"#CCCCCC\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol